// extracted by mini-css-extract-plugin
export default {"key-id":"WdBGgKo8hq","keyId":"WdBGgKo8hq","right-tag":"HIj956HfeE","rightTag":"HIj956HfeE"};